import api from '@pray/shared/utils/api';

export interface ContentTag {
  id: string;
  name: string;
  description: string | null;
  is_suggested: boolean;
  priority: number | null;
}

export interface GetContentTagsResponse {
  data: ContentTag[];
}

export interface GetContentTagsParams {
  artistId: string;
  contentId: string;
}

/**
 * Get all tags for a content item
 */
export async function getContentTags({ artistId, contentId }: GetContentTagsParams): Promise<GetContentTagsResponse> {
  const url = `/web/studio/artists/${artistId}/content/${contentId}/tags`;
  const response = await api.executeGetRequest<GetContentTagsResponse>(url);
  return response.data;
}
